import { render, staticRenderFns } from "./ModalBooking.vue?vue&type=template&id=3890cb80&"
import script from "./ModalBooking.vue?vue&type=script&lang=js&"
export * from "./ModalBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports